/** @jsx isolateComponent */

import { Fragment, ReactNode } from 'react';

import { FlexLayout, MessageBar } from '@zapier/common-components';
import { isolateComponent } from '@zapier/common-utils';
import { Button, Margin } from '@zapier/design-system';
import { PaymentApp } from '@zapier/payment';

import { useSize } from '@zapier/promotions/src/hooks';

type Props = {
  acceptOffer: () => void;
  children: ReactNode;
  error: string | undefined;
  isPaymentMethodProvided: boolean;
};

export const SingleIntervalOfferModalView = ({
  acceptOffer,
  children,
  error,
  isPaymentMethodProvided,
}: Props) => {
  const size = useSize();

  return (
    <Fragment>
      {children}

      <Margin margin="0 auto 20px 0">
        <PaymentApp />
      </Margin>

      {!!error && (
        <Margin margin="0 0 20px 0">
          <MessageBar type="error">{error}</MessageBar>
        </Margin>
      )}

      <FlexLayout
        direction={size === 'small' ? 'column' : 'row'}
        justify="center"
      >
        <Button
          disabled={!isPaymentMethodProvided}
          hasShadow={true}
          isFullWidth={size === 'small'}
          onClick={() => acceptOffer()}
        >
          Upgrade plan
        </Button>
      </FlexLayout>
    </Fragment>
  );
};
